const constants = {
  COMPANY_FORM_PERSON: 'person',
  COMPANY_FORM_EK: 'ek',
  COMPANY_FORM_TRADER: 'trader',
  COMPANY_FORM_FREELANCER: 'freelancer',
  COMPANY_FORM_SOLE_TRADER: 'sole_trader',
  COMPANY_FORM_GBR: 'gbr',
  COMPANY_FORM_OHG: 'ohg',
  COMPANY_FORM_KG: 'kg',
  COMPANY_FORM_GMBH_COKG: 'gmbh_cokg',
  COMPANY_FORM_SILENT: 'silent',
  COMPANY_FORM_OTHER_PARTNERSHIP: 'other_partnership',
  COMPANY_FORM_UG: 'ug',
  COMPANY_FORM_GMBH: 'gmbh',
  COMPANY_FORM_AG: 'ag',
  COMPANY_FORM_LEGAL_FOUNDATION: 'legal_foundation',
  COMPANY_FORM_CHARITABLE_FOUNDATION: 'charitable_foundation',
  COMPANY_FORM_OTHER_COMPANY: 'other_company',

  CONNECTION_TYPE_ONLINE: 'online',
  CONNECTION_TYPE_OFFLINE: 'offline',
  CONNECTION_TYPE_INVITATION: 'taxInvitation',
}

module.exports = constants
